export const styles = {
  folderDetailsContainer: {
    display: "flex",
    justifyContent: "space-between",
    padding: "0px 10px 0px 10px",
    alignItems: "center",
    width: "150px",
  } as const,
  folderName: {
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    width: "120px",
    padding: "0px 10px 0px 10px",
    textAlign: "left",
    fontSize: "15px",
  } as const,
};
